import {
  EN, RU, IT, ES, PL, AE, PT, DE, FR,
} from '../utils/consts';

export const uids = {
  [EN]: {
    CONTACT_US: 'WoRRbigAACgAco9L',
    REGISTRATION: 'Wu7sWiUAAKoBSMxT',
    SHORT_REVIEWS: 'W-0TkBAAACkAeSLm',
    MESSAGE: 'XATS9xAAAEEA1kal',
  },
  [RU]: {
    // HOMEPAGE: 'W_0QkREAAC8AF6jE',
    /* CONTACT_US: 'WoRRbigAACgAco9L',
    REGISTRATION: 'Wu7sWiUAAKoBSMxT', */
    // LANGUAGE_PRACTICE: 'W_1bdREAADMAGO_b',
    // IMMIGRATION_ADVICE: 'W_1Z1hEAAC4AGOiI',
    /* SHORT_REVIEWS: 'W-0TkBAAACkAeSLm', */
    MESSAGE: 'XATouRAAADsA1qY3',
  },
  [IT]: {
    MESSAGE: 'XBpjiBEAACcAYCHS',
  },
  [ES]: {
    MESSAGE: 'XC-L8xEAACMAvKAs',
  },
  [PL]: {
    MESSAGE: 'XEhg5xUAACQAvYtk',
  },
  [AE]: {
    MESSAGE: 'XEhgmRUAACUAvYoL',
  },
  [PT]: {
    MESSAGE: 'XE22fxQAACEALIfu',
  },
  [DE]: {
    MESSAGE: 'XGb1uhAAACgAlRki',
  },
  [FR]: {
    MESSAGE: 'XHVVsBIAACMAg5YJ',
  },
};

export const types = {
  FAQ: 'faq',
  STATIC_PAGE: 'static_page',
  SERVICE_PAGE: 'immigration_advice',
  HOMEPAGE: 'homepage',
};

export const tags = {
  PRIVACY: 'Privacy',
  TERMS: 'Terms',
  IMMIGRATION_ADVICE: 'ImmigrationAdvice',
  IMMIGRATION_CLIENTS: 'ImmigrationAdviceClients',
  LANGUAGE_PRACTICE: 'LanguagePractice',
  LANGUAGE_LEARNERS: 'LanguageLearners',
  CANCELLATION: 'cancellation',
};



// WEBPACK FOOTER //
// ./prismic/uids.js